import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { TableColumn } from '@ui/aos-lib';
import { NameWithDescriptionComponent } from '../../../../../shared/components/listing-table/components/name-with-description.component';
import { UserRole } from '../../user-roles.types';

@Component({
  selector: 'aos-user-role-name-column',
  template: `
    <aos-name-with-description [dataCell]="{ displayName: item.roleName, description: item.description }" />
  `,
  imports: [NameWithDescriptionComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserRoleNameColumnComponent {
  @Input() item!: UserRole;
  @Input() column!: TableColumn;
  @HostBinding('class') fullWidth = 'full-width';
}
